import { render, staticRenderFns } from "./WorkspaceShortcut.vue?vue&type=template&id=0e0c34c9&scoped=true&"
import script from "./WorkspaceShortcut.vue?vue&type=script&lang=js&"
export * from "./WorkspaceShortcut.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceShortcut.vue?vue&type=style&index=0&id=0e0c34c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c34c9",
  null
  
)

export default component.exports